export const SITE = {
  name: "Green Fuse Energy",
  tagline: "Your Global Partner in Industrial Solutions",
  subtagline: "One-Stop Sourcing Partner for Industry",
  logo: "https://customer-assets.emergentagent.com/job_5227c3c3-43c6-4106-9dc9-18b4c35b2efc/artifacts/0isb6ckz_Logo-removebg-preview%20%281%29.png",
  catalogue: "https://customer-assets.emergentagent.com/job_industrysupply-hub/artifacts/r8qn9yhj_Company%20Catalogue.pdf",
  phone: "+91 88138 96466",
  phoneAlt: "+91 86908 76600",
  email: "Energygreenfuse@gmail.com",
  address: "Plot No. 324, Shiv Colony, Gali No. 1, Rewari (Hry) 123401, India",
  gstin: "06CVXPK6637B1Z8",
  whatsapp: "918813896466",
  whatsappMessage: "Hello Green Fuse Energy, I would like to know more about your industrial solutions.",
  stats: {
    categories: 17,
    brandPartners: 80,
    industries: 25,
    countries: 12,
  },
};

export const HERO_IMAGE = "https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg";
export const FACTORY_IMAGE = "https://images.pexels.com/photos/34718930/pexels-photo-34718930.jpeg";
export const TEAM_IMAGE = "https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b";
export const WAREHOUSE_IMAGE = "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9";
export const CONTROL_IMAGE = "https://images.pexels.com/photos/10871565/pexels-photo-10871565.jpeg";
